var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "function-information" },
    [
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "function-information__wrapper" },
            [
              _c("performers-sidesheet", {
                ref: "performersSidesheet",
                attrs: { isLoading: _vm.isLoadingPerfomers },
                on: {
                  goToNextPage: _vm.goToNextPagePerformers,
                  updateList: _vm.updateWorkersListWithFilters,
                  "reset-workers": _vm.resetWorkers,
                },
              }),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-10 col-xl-10" },
                  [
                    _c("c-input", {
                      attrs: {
                        "max-length": 255,
                        "floating-label": "Название",
                        clearable: true,
                        "required-mark": true,
                        required: _vm.isSubmitted && _vm.nameError,
                        "required-condition": _vm.isSubmitted && _vm.nameError,
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-5 col-xl-5" },
                  [
                    _c("c-input", {
                      attrs: {
                        type: "select",
                        label: "Филиал",
                        placeholder: "Все",
                        searchable: true,
                        multiple: true,
                        items: _vm.collections.filials,
                      },
                      model: {
                        value: _vm.form.filials,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "filials", $$v)
                        },
                        expression: "form.filials",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-5 col-xl-5" },
                  [
                    _c("c-input", {
                      attrs: {
                        type: "select",
                        label: "Группа должности",
                        placeholder: "Все",
                        searchable: true,
                        multiple: true,
                        items: _vm.collections.typePosts,
                      },
                      model: {
                        value: _vm.form.typePosts,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "typePosts", $$v)
                        },
                        expression: "form.typePosts",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "function-information__posts" },
                [
                  _c(
                    "h3",
                    { staticClass: "function-information__posts-title" },
                    [_vm._v("Должности исполнителя")]
                  ),
                  _c(
                    "div",
                    { staticClass: "function-information__posts-list" },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: {
                            group: "group",
                            "force-fallback": true,
                            "ghost-class": "sortable__ghost",
                            disabled: _vm.form.posts.length < 2,
                          },
                          model: {
                            value: _vm.form.posts,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "posts", $$v)
                            },
                            expression: "form.posts",
                          },
                        },
                        _vm._l(_vm.form.posts, function (post, j) {
                          return _c(
                            "div",
                            {
                              key: post.id,
                              staticClass:
                                "function-information__posts-item row",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "function-information__posts-item-column col col-12 col-md-4 col-xl-4",
                                },
                                [
                                  _c("c-input", {
                                    attrs: {
                                      type: "select",
                                      label: "Должность",
                                      searchable: true,
                                      placeholder: "Любая",
                                      items: _vm.collections.posts,
                                      clearable: true,
                                    },
                                    model: {
                                      value: post.code,
                                      callback: function ($$v) {
                                        _vm.$set(post, "code", $$v)
                                      },
                                      expression: "post.code",
                                    },
                                  }),
                                  post.code && post.code.value
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "function-information__posts-item-settings",
                                          attrs: {
                                            href: _vm.$router.resolve({
                                              name: "position-form",
                                              params: {
                                                positionCode: post.code.value,
                                              },
                                            }).href,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Перейти к настройке должности "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "function-information__posts-item-column col col-12 col-md-4 col-xl-4",
                                },
                                [
                                  _c("c-input", {
                                    attrs: {
                                      type: "select",
                                      label: "Специальность",
                                      multiple: true,
                                      searchable: true,
                                      placeholder: "Все",
                                      items:
                                        post.code && post.code.collections
                                          ? post.code.collections.specialities
                                          : [],
                                      disabled:
                                        !post.code ||
                                        (post.code.collections &&
                                          !post.code.collections.specialities
                                            .length),
                                      clearable: true,
                                    },
                                    model: {
                                      value: post.specialities,
                                      callback: function ($$v) {
                                        _vm.$set(post, "specialities", $$v)
                                      },
                                      expression: "post.specialities",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "function-information__posts-item-column col col-12 col-md-2 col-xl-2",
                                },
                                [
                                  _c("c-input", {
                                    attrs: {
                                      type: "select",
                                      label: "Разряд",
                                      multiple: true,
                                      searchable: true,
                                      placeholder: "Все",
                                      items:
                                        post.code && post.code.collections
                                          ? post.code.collections.categories
                                          : [],
                                      disabled:
                                        !post.code ||
                                        (post.code.collections &&
                                          !post.code.collections.categories
                                            .length),
                                      clearable: true,
                                    },
                                    model: {
                                      value: post.categories,
                                      callback: function ($$v) {
                                        _vm.$set(post, "categories", $$v)
                                      },
                                      expression: "post.categories",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "function-information__posts-item-actions",
                                },
                                [
                                  _vm.form.posts.length > 1
                                    ? _c("c-button", {
                                        directives: [
                                          {
                                            name: "b-popover",
                                            rawName:
                                              "v-b-popover.hover.blur.top",
                                            value: "Удалить должность",
                                            expression: "'Удалить должность'",
                                            modifiers: {
                                              hover: true,
                                              blur: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        staticClass:
                                          "function-information__posts-item-remove",
                                        attrs: {
                                          icon: {
                                            icon: "trash",
                                            color: "secondary",
                                          },
                                          size: "iconic",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deletePost(post.id)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.form.posts.length > 1
                                    ? _c("c-button", {
                                        directives: [
                                          {
                                            name: "b-popover",
                                            rawName: "v-b-popover.html",
                                            value: {
                                              container: "#app",
                                              trigger: "hover blur",
                                              boundary: "window",
                                              content: "Переместить",
                                              placement: "top",
                                            },
                                            expression:
                                              "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  boundary: 'window',\n                  content: 'Переместить',\n                  placement: 'top',\n                }",
                                            modifiers: { html: true },
                                          },
                                        ],
                                        staticClass:
                                          "function-information__posts-item-move",
                                        attrs: {
                                          size: "iconic",
                                          icon: "arrows-constructor",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _c("c-button", {
                    attrs: {
                      responsive: true,
                      size: "small",
                      label: "Добавить должность",
                      icon: { icon: "plus", color: "primary" },
                      disabled: _vm.addPostIsDisabled,
                    },
                    on: { click: _vm.addPost },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "function-information__performers",
                  attrs: { id: "performers" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "function-information__performers-header" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "function-information__performers-title",
                        },
                        [_vm._v("Исполнители")]
                      ),
                      _vm.workersTotalCount
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "function-information__performers-counter",
                            },
                            [
                              _vm.checkedPerformersListCounter
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.checkedPerformersListCounter) +
                                        " из"
                                    ),
                                  ])
                                : _c("span", [_vm._v("Всего")]),
                              _vm._v(" " + _vm._s(_vm.workersTotalCount) + " "),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "function-information__performers-list" },
                    [
                      _vm._l(_vm.checkedPerformersList, function (performer) {
                        return _c(
                          "div",
                          {
                            key: performer.id,
                            staticClass: "function-information__performer",
                          },
                          [
                            _c("img", {
                              staticClass:
                                "function-information__performer-photo",
                              attrs: {
                                src: `${
                                  performer.photo
                                    ? performer.photo
                                    : "/redesign/img/userpic.svg"
                                }`,
                                width: "34",
                                height: "34",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "function-information__performer-text",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "function-information__performer-name",
                                  },
                                  [_vm._v(_vm._s(performer.fio))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "function-information__performer-filial",
                                  },
                                  [_vm._v(_vm._s(performer.filial_name))]
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "function-information__performer-delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.uncheckPerformer(performer.id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "12",
                                      height: "12",
                                      viewBox: "0 0 12 12",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M0.325608 11.2266C-0.0649162 10.8361 -0.0649162 10.2029 0.325608 9.8124L9.36312 0.773484C9.75364 0.38296 10.3868 0.38296 10.7773 0.773484C11.1679 1.16401 11.1679 1.79717 10.7773 2.1877L1.73982 11.2266C1.3493 11.6171 0.716132 11.6171 0.325608 11.2266Z",
                                        fill: "#FF238D",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M10.6836 11.1641C11.0741 10.7736 11.0741 10.1404 10.6836 9.74992L1.70711 0.773484C1.31658 0.38296 0.683417 0.38296 0.292893 0.773484C-0.0976311 1.16401 -0.0976311 1.79717 0.292893 2.1877L9.26935 11.1641C9.65987 11.5547 10.293 11.5547 10.6836 11.1641Z",
                                        fill: "#FF238D",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm.addCheckedPerformersVisibleCounterIsVisible
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "function-information__performers-list-more",
                              on: {
                                click: _vm.addCheckedPerformersVisibleCounter,
                              },
                            },
                            [
                              _vm._v(
                                "еще " +
                                  _vm._s(_vm.counterShowPerformers) +
                                  " сотрудников"
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.collapseCheckedPerformersListIsVisible
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "function-information__performers-list-collapse",
                              on: {
                                click: function ($event) {
                                  _vm.checkedPerformersVisibleCounter = 9
                                },
                              },
                            },
                            [_vm._v("свернуть")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm.workersTotalCount
                    ? _c("c-button", {
                        staticClass:
                          "function-information__performers-list-change",
                        attrs: {
                          responsive: true,
                          size: "small",
                          label: "Изменить список исполнителей",
                          icon: { icon: "man" },
                        },
                        on: { click: _vm.openPerformersSidesheet },
                      })
                    : _c(
                        "p",
                        {
                          staticClass:
                            "function-information__performers-no-items",
                        },
                        [_vm._v("Нет исполнителей с заданными параметрами")]
                      ),
                ],
                1
              ),
              _c("div", { staticClass: "function-information__settings" }, [
                _c(
                  "h3",
                  { staticClass: "function-information__settings-title" },
                  [_vm._v("Настройки")]
                ),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-12 col-md-10 col-xl-10" },
                    [
                      _c("c-input", {
                        attrs: {
                          type: "select",
                          "floating-label": "Ответственный",
                          searchable: true,
                          multiple: true,
                          items: _vm.collections.responsible,
                        },
                        model: {
                          value: _vm.form.responsible,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "responsible", $$v)
                          },
                          expression: "form.responsible",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-12 col-md-3 col-xl-2" },
                    [
                      _c("c-input", {
                        attrs: {
                          type: "integer-number",
                          label: "Трудозатраты, часов",
                          placeholder: "0",
                          "max-length": 3,
                          clearable: true,
                        },
                        model: {
                          value: _vm.form.laborCosts,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "laborCosts", $$v)
                          },
                          expression: "form.laborCosts",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-5 col-md-2 col-xl-2" },
                    [
                      _c("c-input", {
                        attrs: {
                          type: "integer-number",
                          label: "Частота выполнения",
                          placeholder: "0",
                          "max-length": 2,
                          clearable: true,
                        },
                        model: {
                          value: _vm.form.repeatInterval,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "repeatInterval", $$v)
                          },
                          expression: "form.repeatInterval",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-7 col-md-3 col-xl-2" },
                    [
                      _c("c-input", {
                        staticStyle: { "margin-top": "-5px" },
                        attrs: {
                          type: "select",
                          "floating-label": "Период",
                          items: _vm.collections.repeatTypes,
                          disabled: !_vm.form.repeatInterval,
                        },
                        model: {
                          value: _vm.form.repeatType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "repeatType", $$v)
                          },
                          expression: "form.repeatType",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-12 col-md-10 col-xl-10" },
                    [
                      _c("c-input", {
                        attrs: {
                          type: "select",
                          "floating-label": "Инструменты",
                          searchable: true,
                          multiple: true,
                          items: _vm.collections.tools,
                        },
                        model: {
                          value: _vm.form.tools,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "tools", $$v)
                          },
                          expression: "form.tools",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-12 col-md-10 col-xl-10" },
                    [
                      _c("c-input", {
                        ref: "tasks",
                        attrs: {
                          type: "textarea",
                          "floating-label": "Решаемые задачи",
                          clearable: true,
                        },
                        model: {
                          value: _vm.form.tasks,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "tasks", $$v)
                          },
                          expression: "form.tasks",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-12 col-md-10 col-xl-10" },
                    [
                      _c("c-input", {
                        attrs: {
                          "max-length": 255,
                          "floating-label": "ЦКП функции",
                          clearable: true,
                        },
                        model: {
                          value: _vm.form.vep,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "vep", $$v)
                          },
                          expression: "form.vep",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "function-information__description" },
                [
                  _c(
                    "h3",
                    { staticClass: "function-information__description-title" },
                    [_vm._v("Описание")]
                  ),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col col-12 col-md-10 col-xl-10" },
                      [
                        _c("c-input", {
                          ref: "comment",
                          attrs: {
                            type: "textarea",
                            "floating-label": "Комментарий",
                            clearable: true,
                            "max-length": "255",
                          },
                          model: {
                            value: _vm.form.comment,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "comment", $$v)
                            },
                            expression: "form.comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._l(_vm.form.links, function (link) {
                    return _c(
                      "div",
                      {
                        key: link.id,
                        staticClass: "function-information__link row",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col col-11 col-md-10 col-xl-10" },
                          [
                            _c("c-input", {
                              attrs: {
                                "max-length": 255,
                                "floating-label": "Ссылка",
                                clearable: true,
                              },
                              model: {
                                value: link.value,
                                callback: function ($$v) {
                                  _vm.$set(link, "value", $$v)
                                },
                                expression: "link.value",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col col-1 col-md-11 col-xl-1" },
                          [
                            _vm.form.links.length > 1
                              ? _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.hover.blur.top",
                                      value: "Удалить",
                                      expression: "'Удалить'",
                                      modifiers: {
                                        hover: true,
                                        blur: true,
                                        top: true,
                                      },
                                    },
                                  ],
                                  staticClass:
                                    "function-information__link-remove",
                                  attrs: {
                                    icon: { icon: "trash", color: "secondary" },
                                    size: "iconic",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteLink(link.id)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col col-xl-12 col-md-12 col-12" },
                      [
                        _c("c-button", {
                          attrs: {
                            responsive: true,
                            size: "small",
                            label: "Добавить ссылку",
                            icon: { icon: "plus", color: "primary" },
                            disabled: _vm.addLinkIsDisabled,
                          },
                          on: { click: _vm.addLink },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col col-xl-8 col-md-12 col-12" },
                      [
                        _c("file-loader", {
                          ref: "fileLoader",
                          attrs: {
                            links: _vm.form.fileLinks,
                            format: "images,pdf,docs,video",
                            actions: "loadFiles,preview",
                            limit: 10,
                          },
                          on: {
                            changeLinks: function ($event) {
                              _vm.form.fileLinks = $event
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "note",
                                fn: function () {
                                  return [
                                    _c("div", { staticClass: "note" }, [
                                      _vm._v(
                                        " Допустимые форматы: .jpeg, .jpg, .gif, .png, .mp4, .mov, .mpeg-1,2, .webm, .pdf, .docx. Размер файла — не более 10Мб. "
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2298732054
                          ),
                          model: {
                            value: _vm.form.files,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "files", $$v)
                            },
                            expression: "form.files",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "function__actions function__actions--fixed" },
                [
                  _c("c-button", {
                    staticClass: "function__action",
                    attrs: { label: "Отменить", size: "large" },
                    on: { click: _vm.onReset },
                  }),
                  _c("c-button", {
                    staticClass: "function__action",
                    attrs: {
                      label: "Сохранить",
                      size: "large",
                      color: "primary",
                      disabled: _vm.isSubmitDisabled,
                    },
                    on: { click: _vm.onSubmit },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isLoading
        ? _c("c-loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.isLoading,
              height: "400",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }